import { callApiWithAuthorization } from "../CallApi";

export const getRecommendationUsingUserEntities = async (entityNames, organizationId, projectTypes, skip) => {
    const request = await callApiWithAuthorization(
        "/api/v0/recommend/entity",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                entityNames,
                organizationId,
                projectTypes,
                skip
            })
        }
    );
    const response = await request.json();
    return response;
}

export const getRecommendationUsingUserInput = async (entityNames, organizationId, projectTypes, skip) => {
    const request = await callApiWithAuthorization(
        "/api/v0/recommend/entity/using-input",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                entityNames,
                organizationId,
                projectTypes,
                skip
            })
        }
    );
    const response = await request.json();
    return response;
}

export const getColdStartData = async (organizationId, projectTypes, skip, includeAlwaysRecommended) => {
    const request = await callApiWithAuthorization("/api/v0/recommend/entity/no-data", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            organizationId, projectTypes, skip, includeAlwaysRecommended
        })
    });
    const response = await request.json();
    return response;
}

export const importEntities = async (projectId, data) => {
    const request = await callApiWithAuthorization("/api/v0/recommend/entity/import", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            projectId, data
        })
    });
    const response = await request.json();
    return response;
};

export const getRecommendedEntityRelations = async (entityNames, organizationId, projectId) => {
    debugger
    const request = await callApiWithAuthorization(
        "/api/v0/recommend/relation",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                organizationId,
                entityNames,
                projectId
            })
        }
    );
    const response = await request.json();
    return response;
}

export const importEntityRelations = async (selectedRelations, projectId) => {
    const request = await callApiWithAuthorization(
        "/api/v0/recommend/relation/import",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                selectedRelations,
                projectId,
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function getNumberOfEntitiesAndRelations(projectId) {
    const request = await callApiWithAuthorization(
        `/api/v0/project/${projectId}/numberOfEntitiesAndRelations`,
    );
    const response = await request.json();
    return response;
}